import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { prepareForUpload } from '@/features/messages/attachments';
import { newId } from '@/lib/id';

/**
 * צילומי תפעול: צ'קליסט, משימות וויטרינה (מיגרציה 027).
 *
 * הנתיב מתחיל במזהה הסניף, כי ה RLS על הבדל נגזר ממנו. העלאה לסניף
 * שלא רואים תיחסם בשרת, לא כאן.
 *
 * התמונה מוקטנת לפני ההעלאה: הצילומים נעשים מהטלפון בסניף, לעתים על
 * רשת סלולרית חלשה, והמקור מהמצלמה הוא כמה מגה.
 */

const BUCKET = 'ops';

export async function uploadOpsPhoto(
  branchId: string,
  folder: 'checklist' | 'task' | 'display',
  file: File,
): Promise<string> {
  const prepared = await prepareForUpload(file);
  const ext = prepared.type.split('/')[1]?.replace('jpeg', 'jpg') ?? 'jpg';
  const path = `${branchId}/${folder}/${newId()}.${ext}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, prepared, {
    contentType: prepared.type || 'image/jpeg',
    upsert: false,
  });
  if (error) throw error;
  return path;
}

/** כתובת חתומה לצילום. הבדל פרטי, ולכן אין URL ציבורי. */
export function useOpsPhoto(path: string | null | undefined) {
  return useQuery({
    queryKey: ['ops-photo', path],
    enabled: Boolean(path),
    staleTime: 50 * 60 * 1000,
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await supabase.storage
        .from(BUCKET)
        .createSignedUrl(path as string, 3600);
      if (error) throw error;
      return data?.signedUrl ?? null;
    },
  });
}
